module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/graf_img_pc-b5c656a7732183a05bf9447a8a074983.png";